var g = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, I = /\n/g, O = /^\s*/, T = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, _ = /^:\s*/, b = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, z = /^[;\s]*/, C = /^\s+|\s+$/g, F = `
`, y = "/", A = "*", i = "", G = "comment", L = "declaration";
function M(t, u) {
  if (typeof t != "string")
    throw new TypeError("First argument must be a string");
  if (!t)
    return [];
  u = u || {};
  var a = 1, o = 1;
  function s(n) {
    var r = n.match(I);
    r && (a += r.length);
    var e = n.lastIndexOf(F);
    o = ~e ? n.length - e : o + n.length;
  }
  function f() {
    var n = { line: a, column: o };
    return function(r) {
      return r.position = new l(n), v(), r;
    };
  }
  function l(n) {
    this.start = n, this.end = { line: a, column: o }, this.source = u.source;
  }
  l.prototype.content = t;
  function h(n) {
    var r = new Error(
      u.source + ":" + a + ":" + o + ": " + n
    );
    if (r.reason = n, r.filename = u.source, r.line = a, r.column = o, r.source = t, !u.silent)
      throw r;
  }
  function c(n) {
    var r = n.exec(t);
    if (r) {
      var e = r[0];
      return s(e), t = t.slice(e.length), r;
    }
  }
  function v() {
    c(O);
  }
  function p(n) {
    var r;
    for (n = n || []; r = m(); )
      r !== !1 && n.push(r);
    return n;
  }
  function m() {
    var n = f();
    if (!(y != t.charAt(0) || A != t.charAt(1))) {
      for (var r = 2; i != t.charAt(r) && (A != t.charAt(r) || y != t.charAt(r + 1)); )
        ++r;
      if (r += 2, i === t.charAt(r - 1))
        return h("End of comment missing");
      var e = t.slice(2, r - 2);
      return o += 2, s(e), t = t.slice(r), o += 2, n({
        type: G,
        comment: e
      });
    }
  }
  function d() {
    var n = f(), r = c(T);
    if (r) {
      if (m(), !c(_))
        return h("property missing ':'");
      var e = c(b), E = n({
        type: L,
        property: w(r[0].replace(g, i)),
        value: e ? w(e[0].replace(g, i)) : i
      });
      return c(z), E;
    }
  }
  function x() {
    var n = [];
    p(n);
    for (var r; r = d(); )
      r !== !1 && (n.push(r), p(n));
    return n;
  }
  return v(), x();
}
function w(t) {
  return t ? t.replace(C, i) : i;
}
var N = M;
export {
  N as c
};
